import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CityForm from '../containers/CityFormContainer';
import DocumentHead from '../../../../elements/components/DocumentHead';
import Logger from '../../../../../../lib/Logger';

class CityAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CityAdd.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('City_route_add')} />
          <CityForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CityAddScreen;

Logger.log('silly', `CityAddScreen loaded.`);
